import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import {
  accountOutlineButtonClassName,
  accountSectionClassName,
} from 'pages/account/components/account-styles';
import { CATEGORY_LABELS, type IntegrationApp } from '../integration-apps';
import { AppIconTile } from './app-icon-tile';

interface AvailableAppCardProps {
  app: IntegrationApp;
}

export function AvailableAppCard({ app }: AvailableAppCardProps) {
  const { t } = useTranslation();

  return (
    <li className={cn(accountSectionClassName, 'flex flex-col gap-3 p-4')}>
      <div className="flex items-start justify-between gap-3">
        <AppIconTile icon={app.icon} />
        <button
          type="button"
          aria-label={t('INTEGRATIONS_CONNECT_APP', {
            defaultValue: 'Connect {{app}}',
            app: app.name,
          })}
          className={accountOutlineButtonClassName}
        >
          {t('INTEGRATIONS_CONNECT', { defaultValue: 'Connect' })}
        </button>
      </div>
      <div className="flex flex-1 flex-col gap-1">
        <p className="text-sm font-medium leading-body text-grey-950 dark:text-foreground">
          {app.name}
        </p>
        <p className="flex-1 text-sm text-grey-600 dark:text-muted-foreground">{app.description}</p>
        <p className="pt-1 text-xs leading-heading text-grey-500 dark:text-muted-foreground">
          {CATEGORY_LABELS[app.category]}
        </p>
      </div>
    </li>
  );
}
